module.exports = __webpack_public_path__ + "img/omn.1798270b.svg";